/* ========== Dyke & Dean – Theme Custom Scripts (Alpine-Controlled Version) ========== */

document.addEventListener("DOMContentLoaded", function () {
  // ===== STICKY HEADER LOGIC ONLY =====
  const siteHeader = document.querySelector(".site-header");
  let lastScrollTop = 0;

  window.addEventListener("scroll", function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop && scrollTop > 100) {
      siteHeader?.classList.add("header--is-sticky");
    } else if (scrollTop < lastScrollTop && scrollTop < 100) {
      siteHeader?.classList.remove("header--is-sticky");
    }

    lastScrollTop = scrollTop;
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const expandIcons = document.querySelectorAll('.expand-icon');

  expandIcons.forEach((icon) => {
    icon.addEventListener('click', function () {
      this.classList.toggle('expanded');

      // Optional: Toggle aria-expanded for accessibility
      const expanded = this.classList.contains('expanded');
      this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });
});
